import { ScopeButton } from '@monorepo/shared-lib';
import GuideStepOne from 'assets/images/vies-guide-step1.svg';
import GuideStepTwo from 'assets/images/vies-guide-step2.svg';
import GuideStepThree from 'assets/images/vies-guide-step3.svg';
import GuideStepFour from 'assets/images/vies-guide-step4.svg';
import { StyledCard } from 'components/Custom/card';
import { CardListSpan, CardTitleLargeSpan } from 'components/Custom/spans';
import { VIES_TUTORIAL_HIDE } from 'pages/vies';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultIconClose } from 'shared/styles/common';
import { Preference, PreferenceActions } from 'utils/preferences';

interface ViesGuideProps {
  setShowCard: (show: boolean) => void;
  handlePreferences: (action: PreferenceActions, preference: Preference) => any;
  //renderTopButtons: () => React.ReactNode;
}

const msgBoxWrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  minWidth: 300,
  maxWidth: 300,
  minHeight: 290,
};

const textHeight = 110;

export const ViesGuide: React.FC<ViesGuideProps> = ({
  setShowCard,
  handlePreferences,
  //renderTopButtons,
}) => {
  const { t } = useTranslation();
  const handleClose = () => {
    setShowCard(false);
    handlePreferences(PreferenceActions.SET, {
      name: VIES_TUTORIAL_HIDE,
      value: true,
    });
  };

  return (
    <StyledCard
      width="100%"
      spreadcontent
      fullsize
      hideheader
      style={{
        marginBottom: '20px',
        width: '100%',
        position: 'relative',
      }}
      extra={
        <DefaultIconClose
          role="button"
          tabIndex={0}
          aria-label={t('common.close')}
          style={{
            top: '25',
            position: 'absolute',
            right: '25',
          }}
          onClick={handleClose}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleClose();
            }
          }}
        />
      }
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          width: '100%',
          flexWrap: 'wrap',
          //gap: 50,
        }}
      >
        <div style={msgBoxWrapper}>
          <div style={{ minHeight: textHeight }}>
            <CardTitleLargeSpan>
              {t('vat-checker.guide-activate-entity-title')}
            </CardTitleLargeSpan>

            <CardListSpan>
              <p style={{ paddingInlineStart: 3, maxWidth: 330, margin: 0 }}>
                {t('vat-checker.guide-activate-entity-description')}
              </p>
            </CardListSpan>
          </div>
          <div style={{ marginBottom: 10 }}>
            <img
              alt={t('vat-checker.guide-activate-entity-title')}
              src={GuideStepOne}
            />
          </div>
        </div>
        <div style={msgBoxWrapper}>
          <div style={{ minHeight: textHeight }}>
            <CardTitleLargeSpan>
              {t('vat-checker.guide-take-action-title')}
            </CardTitleLargeSpan>
            <CardListSpan>
              <p style={{ paddingInlineStart: 3, maxWidth: 330, margin: 0 }}>
                {t('vat-checker.guide-take-action-description')}
              </p>
            </CardListSpan>
          </div>
          <div>
            <img
              alt={t('vat-checker.guide-take-action-title')}
              src={GuideStepTwo}
            />
          </div>
        </div>

        <div style={msgBoxWrapper}>
          <div style={{ minHeight: textHeight }}>
            <CardTitleLargeSpan>
              {t('vat-checker.guide-monitor-title')}
            </CardTitleLargeSpan>
            <CardListSpan>
              <p style={{ paddingInlineStart: 3, maxWidth: 330, margin: 0 }}>
                {t('vat-checker.guide-monitor-description')}
              </p>
            </CardListSpan>
          </div>

          <div>
            <img
              alt={t('vat-checker.guide-monitor-title')}
              src={GuideStepThree}
            />
          </div>
        </div>
        <div style={msgBoxWrapper}>
          <div style={{ minHeight: textHeight }}>
            <CardTitleLargeSpan>{t('vat-checker.history-log')}</CardTitleLargeSpan>
            <CardListSpan>
              <p style={{ paddingInlineStart: 3, maxWidth: 330, margin: 0 }}>
                {t('vat-checker.guide-history-description')}
              </p>
            </CardListSpan>
          </div>

          <div>
            <img alt={t('vat-checker.history-log')} src={GuideStepFour} />
          </div>
        </div>
      </div>
      <ScopeButton
        type="default"
        onClick={handleClose}
        style={{
          position: 'absolute',
          bottom: 16,
          right: 16,
          width: 'auto',
          height: 28,
          fontSize: '12px',
          padding: '0 12px',
        }}
      >
        {t('common.close')}
      </ScopeButton>
    </StyledCard>
  );
};
